<template>
<div >
    <div class="text-center">
      <p class="font-medium mb-4">  {{ userInfo.name }}/ {{ schoolType }} {{ schoolGrade }}</p>
      <vs-avatar size="70px" icon-pack="feather" icon="icon-user" color="success"/>
      <p class="text-primary"> 반갑습니다!</p>
    </div>
</div>
</template>

<script>
import { fetchData } from '@/api/module'

export default {
  components: {
  },
  data () {
    return {
      studentInfo: null,
      userInfo: {}
    }
  },
  watch: {
  },
  computed: {
    schoolGrade () {
      if (this.studentInfo === null) return
      return `${parseInt(this.studentInfo.schoolGrade) + 1  }학년`
    },
    schoolType () {
      if (this.studentInfo === null) return
      
      if (this.studentInfo.schoolType === 0) {
        return '초등'
      } else if (this.studentInfo.schoolType === 1) {
        return '중등'
      } else if (this.studentInfo.schoolType === 2) {
        return '고등'
      } else {
        return ''
      }
    }
  },
  methods: {
    async loadStudentInfo () {
      try { 
        const { data } = await fetchData(`/student/${  this.userInfo.userID  }`)
        this.studentInfo = data.data
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    this.loadStudentInfo()
  }
}

</script>

